export default __webpack_public_path__ + "static/media/Delegacion(B).87bc5cad.svg";